export default __webpack_public_path__ + "static/media/in-progress-banner.82f1de2c.png";